import React from 'react';
import { useSelector } from 'react-redux';
import { GridWrapper } from '@yme/atoms/grid';
import { Image as ImageAtom } from '@yme/atoms/image';
import { useTestRideDealers } from '@yme/components/TestRide/components/TestRideGrid/useTestRideDealers';
import { getTestRideIframe } from '@yme/components/TestRide/redux/selectors';
import { useHideHeaderAndFooter, useKioskHomeUrl, useWindowSize } from '@yme/hooks/index';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack700, colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ContentBlock } from './ContentBlock';
import { Navigation } from './Navigation';
import { SubTitleStyled, TitleStyled, HeroComponentStyled, ImageBgStyled, FlexWrapperStyled, PageContainerStyled, } from './styled';
export function Error404(props) {
    const { backgroundImage, button: primaryButton, homeLink, title, subtitle, description, labels, } = props;
    const isRightToLeft = useSelector(getRTL);
    const isIframeFromRedux = useSelector(getTestRideIframe);
    const { isMobileView } = useWindowSize();
    const homeKioskLink = useKioskHomeUrl(homeLink);
    const { isIframe } = useTestRideDealers();
    const isIframeCondition = isIframe || isIframeFromRedux;
    useHideHeaderAndFooter(isIframeCondition);
    const secondaryButton = {
        text: labels.error404_homePageButton_text,
        link: homeKioskLink,
    };
    if (title) {
        return (React.createElement(PageContainerStyled, { isHidden: isIframeCondition, ...(isRightToLeft
                ? {
                    dir: 'rtl',
                }
                : {}) },
            React.createElement(HeroComponentStyled, null,
                React.createElement(ImageBgStyled, null,
                    React.createElement(ImageAtom, { ...backgroundImage })),
                React.createElement(GridWrapper, { containerProps: {
                        height: '100%',
                    }, rowProps: {
                        height: '100%',
                    } },
                    React.createElement(Navigation, { isRightToLeft: isRightToLeft, pageNotFoundTitle: labels.error404_pageNotFound_title, needAssistanceTitle: labels.common_needAssistance_title }),
                    React.createElement(FlexWrapperStyled, { flexDirection: "column", justifyContent: "flex-end" },
                        React.createElement(SubTitleStyled, { color: colorCoreWhite1000 }, subtitle),
                        React.createElement(FlexWrapper, { mt: "4px" },
                            React.createElement(TitleStyled, { color: colorCoreWhite1000 }, title)),
                        !isMobileView && (React.createElement(ContentBlock, { description: description, primaryButton: primaryButton, secondaryButton: secondaryButton, isButtonsHidden: isIframeCondition }))))),
            isMobileView && (React.createElement(GridWrapper, { containerProps: {
                    bgColor: colorCoreBlack700,
                } },
                React.createElement(ContentBlock, { description: description, primaryButton: primaryButton, secondaryButton: secondaryButton, isButtonsHidden: isIframeCondition })))));
    }
    return null;
}
Error404.displayName = 'Error404_AEMComponent';
